import styled from 'styled-components';

const StyledPeopleGrid = styled.div`
  position: relative;
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
`;

export {
  StyledPeopleGrid,
};

